import {
  PREVIEW_HOSTNAME,
  isTestEnvironment,
  useAuth,
} from '@spotify/confidence-core-react';

type AppRedirectResult =
  | { shouldRedirect: false }
  | { shouldRedirect: true; targetUrl: string };

export function useAppRedirect(preferredUrl: string): AppRedirectResult {
  const { orgName } = useAuth();

  if (
    !orgName ||
    !preferredUrl ||
    preferredUrl === window.location.origin ||
    process.env.NODE_ENV === 'development' ||
    isTestEnvironment() ||
    window.location.hostname === PREVIEW_HOSTNAME
  ) {
    return { shouldRedirect: false };
  }

  return {
    shouldRedirect: true,
    targetUrl: preferredUrl,
  };
}
